// src/hooks/useDateSponsor.js
import {useQuery} from 'react-query';
import {fetchDateSponsorList} from "../api/dateSponsorApi";

export const useDateSponsor = () => {
    return useQuery(['dateSponsor'], () => fetchDateSponsorList(), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
